import type { Transition } from "motion/react";
import type { MD3Size } from "../../../types/md3";

/**
 * Spring motion specification for ButtonDistribute.
 * Per spec: framer-motion spring config (stiffness: 300, damping: 30) or 300ms - 450ms cubic-bezier.
 */
export const DISTRIBUTE_SPRING_TRANSITION: Transition = {
	type: "spring",
	stiffness: 300,
	damping: 30,
	mass: 0.8,
};

export const DISTRIBUTE_EASING_BEZIER = "cubic-bezier(0.2, 0.0, 0.0, 1.0)";
export const DISTRIBUTE_DURATION_MS = 350;

/** Default expand ratio added to active weight in dynamic mode */
export const DEFAULT_EXPAND_RATIO = 0.3;

/** Default fixed size for leading/trailing buttons in mixed mode */
export const DEFAULT_FIXED_SIZE = 48;

/** Default gap between buttons */
export const DEFAULT_GAP = "0.5rem";

/**
 * Circle / Pill radius values per MD3 size token for dynamic morphing.
 */
export const DISTRIBUTE_RADIUS_TOKENS: Record<
	MD3Size,
	{ circleRadius: number; pillRadius: number; pressedRadius: number }
> = {
	xs: { circleRadius: 16, pillRadius: 16, pressedRadius: 8 },
	sm: { circleRadius: 20, pillRadius: 20, pressedRadius: 10 },
	md: { circleRadius: 28, pillRadius: 28, pressedRadius: 16 },
	lg: { circleRadius: 48, pillRadius: 48, pressedRadius: 28 },
	xl: { circleRadius: 68, pillRadius: 68, pressedRadius: 40 },
};

/**
 * Container height per MD3 size token for ButtonDistribute.
 */
export const DISTRIBUTE_HEIGHT_TOKENS: Record<MD3Size, string> = {
	xs: "h-8",
	sm: "h-10",
	md: "h-14",
	lg: "h-24",
	xl: "h-[8.5rem]",
};
